import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FileUploadComponent } from './file-upload/file-upload.component';
import { DragAndDropDirective } from './file-upload/drag-and-drop.directive';
import { TranslocoModule } from '@ngneat/transloco';
import { ButtonModule } from '../../button/button.module';
import { IconModule } from '../../icon/icon.module';
import { DotIndicatorModule } from '../../dotindicator/dotindicator.module';

@NgModule({
  declarations: [FileUploadComponent, DragAndDropDirective],
  imports: [
    CommonModule,
    IconModule,
    TranslocoModule,
    ButtonModule,
    DotIndicatorModule,
  ],
  exports: [FileUploadComponent],
})
export class FileUploadModule {}
